import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalService } from '../../services/local.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  user = new BehaviorSubject<any | null>(null);

  constructor(private localService: LocalService) { }

  autoLoginUser() {
    // const data = localStorage.getItem('loginUserData')??'[]';
    const data = this.localService.getJsonValue('loginUserData') ?? '[]';
    const __userData = JSON.parse(data);
    if (!__userData) {
      return;
    }
    this.user.next(__userData);
  }

  // Method to get the auth token
  getAuthToken(): string | null {
    const data = this.localService.getJsonValue('loginUserData') ?? '[]';
    const __userData = JSON.parse(data);
    if (!__userData) {
      return null;
    }
    return __userData.access_token;
  }

  getLoggedInUserId(): string | null {
    const data = this.localService.getJsonValue('loginUserData') ?? '[]';
    const __userData = JSON.parse(data);
    if (!__userData) {
      return null;
    }
    return __userData.id;
  }

}
